import {
	AddEventTagFormData,
	ApiResponse,
	EventTagGetApiResponse,
	EventTagListApiResponse,
	UpdateEventTagRequest,
} from "../context/EventTagContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	EVENT_TAG: "/cms/event-tag",
};

export class EventTagService {
	static async getEventTagList(): Promise<EventTagListApiResponse> {
		const response = await axiosInstance.get(ENDPOINTS.EVENT_TAG);
		return response.data;
	}

	static async getEventTagDetails(eventTagId: string): Promise<EventTagGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.EVENT_TAG}/${eventTagId}`);
		return response.data;
	}

	static async addEventTag(tagData: AddEventTagFormData): Promise<ApiResponse<unknown>> {
		const response = await axiosInstance.post(ENDPOINTS.EVENT_TAG, {
			tagIcon: tagData.tagIcon,
			eventTagLocalizable: tagData.eventTagLocalizable.map(item => ({
				culture: item.culture,
				tagName: item.tagName.trim(),
			})),
		});
		return response.data;
	}

	static async updateEventTag(request: UpdateEventTagRequest): Promise<ApiResponse<unknown>> {
		const response = await axiosInstance.patch(ENDPOINTS.EVENT_TAG, request);
		return response.data;
	}

	static async removeEventTag(eventTagId: string): Promise<ApiResponse<unknown>> {
		const response = await axiosInstance.delete(`${ENDPOINTS.EVENT_TAG}/${eventTagId}`);

		if (response.status === 204) {
			return { result: null, error: null, isSuccessful: true };
		}

		return response.data;
	}
}
